<template>
  <v-container class="fill-height d-flex justify-center align-center" fluid>
    <v-card class="justify-center ma-12">
      <v-card-title>
        <p>Verify Phone Number</p>
      </v-card-title>
      <v-card-subtitle class="py-0">
        <p>
          Please click the button below to verify your phone number.
        </p>
      </v-card-subtitle>
      <v-card-text>
        <VerifyPhoneBtn />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  import VerifyPhoneBtn from "./VerifyPhoneBtn";

  export default {
    name: "VerifyPhonePage",
    components: { VerifyPhoneBtn },
  };
</script>



// WEBPACK FOOTER //
// src/components/VerifyPhone/VerifyPhonePage.vue